<!--suppress CssUnresolvedCustomProperty -->
<template>
    <div class="bg_main" v-resize="onResize" :style="cssProps">
        <!--<div style="display: flex; justify-contnet: left; align-items: left; max-width: 100vw;">
            <v-chip large style="margin: 5px 5px; cursor: pointer;" class="font-weight-bold" v-for="category in processesStore.categories" :key="category.id"
                v-bind:class="currentCategoryId == category.id ? 'main_color white--text': 'main_color--text'" @click="getProcessesByCategory(category)">
                <v-icon style="margin: 0 15px 0 5px" :class="currentCategoryId == category.id ? 'main_color white--text': 'main_color--text'" large left>
                    mdi-chart-donut
                </v-icon>
                {{ category.nombre.split('')
                    .map((letter, index) =>
                    index ? letter.toLowerCase() : letter.toUpperCase(),
                    )
                    .join('') }}
            </v-chip>
        </div> -->

        <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
        <v-row>
            <v-col :cols="isMobile ? '9' : '11'" class="pt-0 pb-0">
                <v-text-field
                    type="text"
                    solo
                    placeholder="Buscar procesos"
                    v-model="search"
                    @keyup.enter="getProcessesByCategory"
                />
            </v-col>
            <v-col :cols="isMobile ? '3' : '1'" class="pt-0 pb-0">
                <v-btn class="main_color white--text" large @click="getProcessesByCategory">
                    <v-icon class="main_color white--text">
                        mdi-magnify
                    </v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="pt-0">
                <v-card class="py-2 px-4 processes-list">
                    <v-row v-if="processesStore.categories">
                        <v-col>
                            <v-chip large style="margin: 5px 5px; cursor: pointer;" class="pa-2 font-weight-bold" v-for="category in processesStore.categories" :key="category.id"
                                v-bind:class="currentCategoryId == category.id ? 'main_color_action white--text': 'main_color--text'" @click="getProcessesByCategory(category)">
                                <v-icon style="margin: 0 15px 0 5px" :class="currentCategoryId == category.id ? 'main_color_action white--text': 'main_color--text'" large left>
                                    mdi-chart-donut
                                </v-icon>
                                {{ textCapitalize(category.nombre)}}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <!-- <v-card class="d-flex justify-center d-relative m-0 categories-header" flat tile v-if="processesStore.categories">
                        <v-chip large style="margin: 5px 5px; cursor: pointer;" class="font-weight-bold" v-for="category in processesStore.categories" :key="category.id"
                            v-bind:class="currentCategoryId == category.id ? 'main_color white--text': 'main_color--text'" @click="getProcessesByCategory(category)">
                            <v-icon style="margin: 0 15px 0 5px" :class="currentCategoryId == category.id ? 'main_color white--text': 'main_color--text'" large left>
                                mdi-chart-donut
                            </v-icon>
                            {{ category.nombre.split('')
                                .map((letter, index) =>
                                index ? letter.toLowerCase() : letter.toUpperCase(),
                                )
                                .join('') }}
                        </v-chip>
                        <v-card
                            v-for="category in processesStore.categories"
                            :key="category.id" class=" py-2 px-4 hidden-sm-and-down" flat
                            @click="getProcessesByCategory(category)"> -->

                            <!-- FOR DESKTOP -->
                            <!-- <v-row class="category-menu align-center" v-bind:class="currentCategoryId == category.id ? 'selected': ''">
                                <div class="mr-2">
                                    <svgicon v-bind:name="loadSVGIcon(category.icono)" height="3em" fill-current="primary"></svgicon>
                                </div>
                                <div class="title text-caption font-weight-bold" v-bind:class="currentCategoryId == category.id ? 'primary--text': 'grey--text'">{{ category.nombre }}</div>
                            </v-row>
                        </v-card> -->

                        <!-- FOR TABLET AND MOBILE -->
                        <!--<v-menu bottom origin="center center" transition="scale-transition" class="hidden-md-and-up">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on" width="100%" class="hidden-md-and-up">

                                    <v-list-item-icon class="category-menu selected">
                                        <svgicon v-bind:name="getSelectedCategoryIcon()" height="2.5em" fill-current="primary"></svgicon>
                                    </v-list-item-icon>

                                    <v-list-item-content class="ml-2 primary--text">
                                        {{ getSelectedCategoryLabel() }}
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-icon right color="primary">fas fa-chevron-down</v-icon>
                                    </v-list-item-action>

                                </v-list-item>
                            </template>

                            <v-list >
                                <v-list-item v-for="(category, i) in processesStore.categories" :key="'c'+i" link @click="getProcessesByCategory(category)">
                                    <v-list-item-icon>
                                        <svgicon v-bind:name="loadSVGIcon(category.icono)" height="2em" fill-current="primary"></svgicon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ category.nombre }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu> 
                    </v-card>-->

                    <v-divider class="mt-2 mb-2"></v-divider>

                    <v-row v-if="processesStore.categories">
                        <v-col cols="6" md="4" lg="2" v-for="(process, index) in processesStore.processes" :key="process.id">
                            <v-card :id="'cardproccess'+index" class="pa-2" style="padding: 10px" height="250"
                                @mouseover="onHoverProcess($event, index)"
                                @mouseleave="outHoverProcess($event, index)"
                                @click="goTo(process)">
                                <div style="display: flex; justify-content: center">
                                    <v-icon :id="'cardproccess_i'+index" class="main_color--text" large>mdi-chart-donut</v-icon>
                                </div>
                                <v-card-title class="justify-center lh-1" :style="{wordBreak: 'normal', textAlign: 'center'}">{{textCapitalize(process.nombre)}}</v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!--<v-row v-if="processesStore.processes">
                        <v-col cols="6"  md="4" lg="2" v-for="process in processesStore.processes " :key="process.id">
                            <router-link :to="{ name: 'process_requirement', params: { processId: process.id, processName: process.nombre}}" class="text-decoration-none">
                                <v-card flat class="tramite_ico text-center py-6 justify-center align-center" height="100%">
                                    <div class="process-icon">
                                        <svgicon v-if="!process.icon" v-bind:name="loadSVGIcon('tramite.svg')" height="3em" fill-current="primary"></svgicon>
                                        <img v-else :src="process.icon" width="70" fill-current="primary"/>
                                    </div>
                                    <v-card-text class="text-left font-weight-bold ml-2 pt-0 pb-0 grey--text">{{ process.nombre }}</v-card-text>
                                </v-card>
                            </router-link>
                        </v-col>
                    </v-row>-->
                </v-card>
            </v-col>
        </v-row>
        <!-- END TABLE FOR PROCESSES   -->

    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {processListRequest} from "../api/models/";

export default {
    name: "Processes",
    components: {
    },
    computed: {
        ...mapState({accountStore: state => state.account, processesStore: state => state.processes}),

        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary,
                '--main-color': this.$vuetify.theme.themes.light.main_color,
            }
        }
    },
    data() {
        return {
            currentCategoryId: 1,
            showIdentidad: true,
            selectedCategory: null,
            isMobile: false,
            search:'',
        }
    },

    created() {
        this.$gtag.event('nuevo_tramite', { method: 'Google' }) // Google Analytics
    },

    mounted() {
        //Call to VueX module action
        this.getCategories()

        //Call to local method
        this.getProcessesByCategory(null)
    },

    methods: {
        ...mapActions('processes', ['getProcesses', 'getCategories']),

        goTo(process){
            this.$router.push({ name: 'process_requirement', params: { processId: process.id, processName: process.nombre}})
        },

        textCapitalize(val){
            var str = val.split('')
                        .map((letter, index) =>
                        index ? letter.toLowerCase() : letter.toUpperCase(),
                        )
                        .join('')
            // var txt = str.charAt(0).toUpperCase() + str.slice(1);

            return str
        },

        onHoverProcess(event, n){
            var s = document.getElementById('cardproccess'+n)
            var i = document.getElementById('cardproccess_i'+n)
            s.classList.add('main_color')
            s.classList.add('white--text')
            i.classList.remove('main_color--text')
            i.classList.add('white--text')
            // event.target.className += ' main_color'
        },

        outHoverProcess(event, n){
            var s = document.getElementById('cardproccess'+n)
            var i = document.getElementById('cardproccess_i'+n)
            s.classList.remove('main_color')
            s.classList.remove('white--text')
            i.classList.remove('white--text')
            i.classList.add('main_color--text')
            // event.target.className.replace(' main_color', '') 
        },

        getProcessesByCategory(category){
            if (category == null || category.id !== this.currentCategoryId){
                this.selectedCategory = category
                this.currentCategoryId = category ? category.id : 1

                let request = processListRequest()
                request.category_id = this.currentCategoryId
                request.type_of_person = this.accountStore.user.tipo_persona
                request.query = this.search

                this.getProcesses(request)
                this.search = '';
            }
        },

        loadSVGIcon(iconName){
            import('./../components/icons/'+iconName.slice(0, -4));

            return iconName.slice(0, -4)
        },

        /** FOR MOBILE **/
        getSelectedCategoryIcon(){
            return this.loadSVGIcon(
                this.selectedCategory ? this.selectedCategory.icono: this.processesStore.categories[0].icono
            )
        },

        getSelectedCategoryLabel(){
            return this.selectedCategory ? this.selectedCategory.nombre: this.processesStore.categories[0].nombre
        },
        onResize() {
            if (window.innerWidth < 769) this.isMobile = true;
            else this.isMobile = false;
        },
        /** ENDS FOR MOBILE **/
    },
}
</script>

<style scoped>
    .category-menu .title{max-width: 170px}
    .category-menu .title{max-width: 170px}
    .category-menu.selected svg{
        fill: var(--main-color) !important;
        opacity: 1;    
    }
    .category-menu svg {
        fill: #b3b3b3;
    }
    .tramite_ico svg{
        fill: #555;
    }
    .tramite_ico .v-card__text{
        color: #555 !important;
    }
    /* .category-menu.selected .prefix__cls-1{fill:var(--primary-color)} */
    .categories-header {min-height: 40px}
    .processes-list {min-height: 80vh}
    .process-icon{height: 70px; overflow: hidden}
</style>